import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withOktaAuth } from '@okta/okta-react';
import { Redirect } from 'react-router-dom';

import LoginForm from './LoginForm';
import { Spinner } from '../components/';
import LoginContainer from '../components/containers/LoginContainer';

import { modalTypes } from '../types/modal';

export class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      authenticated: null,
      isLoading: false
    };
  }

  async componentDidMount() {
    await this.checkAuthentication();
  }

  async checkAuthentication() {
    const { authState } = this.props;

    const isAuthenticated = authState?.isAuthenticated;

    const { authenticated: authenticatedState } = this.state;

    if (isAuthenticated !== authenticatedState) {
      this.setState({ authenticated: isAuthenticated });
    } else if (!authenticatedState) {
      localStorage.clear();
    }
  }

  render() {
    const { authenticated, isLoading } = this.state;

    return authenticated ? (
      <Redirect to={{ pathname: '/' }} />
    ) : (
      <>
        <LoginContainer>
          <div className='loginPage__form pb10-sm'>
            <h1 className='display-2 mb8-sm ta-sm-c'>GAMEDAY ADMIN</h1>
            <LoginForm />
          </div>
        </LoginContainer>
        {isLoading && (
          <>
            <div className='modal__disabledOverlay_back u-full-width u-full-height bg-white z0' />
            <Spinner large />
          </>
        )}
      </>
    );
  }
}

LoginPage.defaultProps = {
  oktaAuth: null
};

LoginPage.propTypes = {
  ...modalTypes,
  oktaAuth: PropTypes.shape({
    signInWithRedirect: PropTypes.func.isRequired
  })
};

export default withOktaAuth(LoginPage);
